import clsx from 'clsx';
import React from 'react';

import { Icon, LazyImage } from '..';
import { colors } from '../../assets/styles';
import { getImageUrl } from '../../utils';

import styles from './styles';

export interface HeroProps {
  status: 'none' | 'sending' | 'granted' | 'denied' | 'unlocked';
  title: string;
  subtitle: string;
  cloudId?: string | null;
  imageAlt: string;
}

const renderHeroBadge = (state: HeroProps['status']) => {
  switch (state) {
    case 'sending':
      return (
        <div
          className={styles.imageBadge}
          style={{
            backgroundColor: colors.primary,
            padding: '15px 14px 0px 10px',
          }}
        >
          <Icon.Send color={colors.white} />
        </div>
      );
    case 'granted':
      return (
        <div
          className={styles.imageBadge}
          style={{
            backgroundColor: colors.success,
            padding: '17px',
          }}
        >
          <Icon.Checkmark color={colors.white} />
        </div>
      );
    case 'denied':
      return (
        <div
          className={styles.imageBadge}
          style={{
            backgroundColor: colors.error,
            padding: '14px',
          }}
        >
          <Icon.Lock color={colors.white} />
        </div>
      );
    case 'unlocked':
      return (
        <div
          className={styles.imageBadge}
          style={{
            backgroundColor: colors.success,
            padding: '17px',
          }}
        >
          <Icon.Unlock color={colors.white} />
        </div>
      );
    case 'none':
    default:
      return null;
  }
};

const Hero: React.FC<HeroProps> = (props) => {

  const imageUrl = props.cloudId
    ? getImageUrl(props.cloudId, { width: 150, crop: 'scale' })
    : '';

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {props.title}
      </div>
      <div className={styles.subtitle}>
        {props.subtitle}
      </div>
      <div className={styles.imageWrapper}>
        <div
          className={styles.imageContainer}
          style={{
            WebkitMaskImage: '-webkit-radial-gradient(white, black)',
            backgroundColor:
              props.status === 'sending' ? colors.greyBackground
                : (props.status === 'granted' || props.status === 'unlocked') ? colors.success
                  : props.status === 'denied' ? colors.error
                    : colors.white,
          }}
        >
          {/* Rotating Loading Circle */}
          <div
            style={{ display: props.status === 'sending' ? 'block' : 'none' }}
            className={clsx([
              styles.imageLoadingCircle,
              styles.imageLoadingCircleAnimation,
            ])}
          />
          <div className={styles.imageOutline}>
            <LazyImage
              className={styles.image}
              src={imageUrl}
              alt={props.imageAlt}
            />
          </div>
        </div>
        {/* Circular Hero Badge */}
        {renderHeroBadge(props.status)}
      </div>
    </div>
  );
};

export default Hero;
